import { Button, createStyles, makeStyles, Theme } from "@material-ui/core";
import { Language } from "@material-ui/icons";
import { LoggerFactory } from "lego-gui-lib/lib";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getLanguageTag, LanguageCode, languages } from "../../core/i18n/i18n";
import { mainStore } from "../../core/mainStore";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      marginRight: theme.spacing(1)
    },
    container: {
      margin: "0px 8px"
    }
  })
);

export const LanguageSelector: FunctionComponent = observer(() => {
  const log = LoggerFactory.create("LanguageSelector");
  const classes = useStyles();
  const { i18n } = useTranslation();

  const [storedLanguage, setStoredLanguage] = useState<string>(
    window.localStorage.getItem("language") || ""
  );

  useEffect(() => {
    window.localStorage.setItem("language", storedLanguage);
    log.debug("Language from storage", storedLanguage);
  }, [log, storedLanguage]);

  const changeLanguage = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    languageCode: LanguageCode
  ) => {
    i18n.changeLanguage(languageCode);
    setStoredLanguage(languageCode);
    mainStore.api.setAcceptLanguage(getLanguageTag(languageCode));
    log.debug("lang changed to ", languageCode);
  };

  return (
    <span className={classes.container}>
      {languages.map((lang, key) => (
        <LanguageButton
          key={key}
          languageCode={lang.languageCode}
          languageName={lang.languageName}
          changeLanguage={changeLanguage}
          storedLanguage={storedLanguage}
        />
      ))}
    </span>
  );
});

interface LanguageButtonProps {
  changeLanguage: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    languageCode: LanguageCode
  ) => void;
  languageCode: LanguageCode;
  languageName: string;
  storedLanguage: string;
}

const LanguageButton: FunctionComponent<LanguageButtonProps> = (
  props: LanguageButtonProps
) => {
  const classes = useStyles();
  const { changeLanguage, languageCode, languageName, storedLanguage } = props;
  return (
    <Button
      disabled={storedLanguage === languageCode}
      startIcon={<Language />}
      className={classes.button}
      onClick={event => changeLanguage(event, languageCode)}
    >
      {languageName}
    </Button>
  );
};
